<template>
    <div class="bg">
        <v-container>
          <div class="center nav">
            <v-icon style="position: absolute; left: 20px;color:#fff" @click="previous()"
              >mdi-arrow-left</v-icon
            >
            <v-spacer></v-spacer>
            <h2 style="margin-bottom: 0;color:#fff">Create Branch</h2>
            <v-spacer></v-spacer>
          </div>

           <!-- content -->
          <div :style="`height:${height}px;min-height: 70vh;border-radius: 20px;background:#fff;overflow: scroll;`">
            <v-container>
                <!-- <div style="overflow: scroll;"> -->
                <div class="center image" @click="aa">
                    <div style="display:flex;justify-content:center;align-items:center;height:233px">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2FAdd%20Cover%20(4).png?alt=media&token=bfbb7a6d-6054-4d32-8ed0-c5ce5a5b312b" alt="">
                    </div>

                </div>
                <div style="padding-top: 20px;">
                    <p><span style="color:#ff0000">* </span>Branch</p>
                    <v-text-field
                        placeholder="Enter branch"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-text-field>
                    <p><span style="color:#ff0000">* </span>Phone</p>
                     <v-text-field
                        placeholder="Enter branch"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-text-field>
                    <p>Google map</p>
                    <v-text-field
                        placeholder="Enter branch"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-text-field>
                </div>
                <!-- </div> -->
                <!-- <p style="color:#000"><span style="color:#ff0000">* </span>Service / Products</p>
                <v-text-field
                    placeholder="Enter Service / Products"
                    solo
                    flat
                    hide-details
                    style="border-radius: 20px;
        border: 2px solid var(--neutral-grey-5, #EFEEFC);
        background: var(--neutral-white, #FFF);"
                ></v-text-field>
                <p style="color:#000;padding-top:10px;"><span style="color:#ff0000">* </span>Description</p>
                <v-text-field
                        placeholder="Enter  phone number"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
            border: 2px solid var(--neutral-grey-5, #EFEEFC);
            background: var(--neutral-white, #FFF);"
                ></v-text-field>
                <p style="color:#000;padding-top:10px;"><span style="color:#ff0000">* </span>Point Conversion Rate</p>
                <div class="row" style="padding-bottom:40px">
                    <div class="col">
                         <v-text-field
                        placeholder=""
                        solo
                        flat
                        hide-details
                        suffix="THB"
                        style="border-radius: 20px;
            border: 2px solid var(--neutral-grey-5, #EFEEFC);
            background: var(--neutral-white, #FFF);"
                        ></v-text-field>
                    </div>
                    <span style="display:flex;align-items:center">=</span>
                    <div class="col">
                         <v-select
                        placeholder=""
                        solo
                        flat
                        hide-details
                        suffix="Point"
                        style="border-radius: 20px;
            border: 2px solid var(--neutral-grey-5, #EFEEFC);
            background: var(--neutral-white, #FFF);"
                        ></v-select>
                    </div>
                </div>
                <div class="" style="border-radius: 16px;border: 1px solid #EEF3FC;background: #FFF;height:76px;display:flex;align-items:center;">
                    <div class="col">Show information</div>
                    <div class="col text-right">
                        <v-switch class="float-right" color="#25388D"></v-switch>
                    </div>
                </div> -->
                <div style="display:flex;justify-content:center;">
                    <v-btn block dark color="#25388D" class="btn-ok">save</v-btn>
                </div>
            </v-container>
          </div>
          <!-- content -->
          <div class="foot">POWER BY  BETASK CONSULTING</div>
        </v-container>

    </div>
</template>

<script>
// import axios from 'axios' // api
export default {
  name: 'LoyaltySystemConvertRate',

  data () {
    return {
      height: '',
      ProductExchangeRate: [],
      session: this.$session.getAll()

    }
  },

  mounted () {
    this.checkDeviceHeight()
  },

  methods: {
    checkDeviceHeight () {
      // Get the viewport height
      const viewportHeight = window.innerHeight
      this.height = viewportHeight - 162
    },
    aa () {
      alert('aa')
    }

  }
}
</script>

<style scoped>
    .bg {
        background: #25388D;
        height: 100vh;
        width: 100%;
    }
    .nav {
  display: flex;
  align-items: center;
  height: 100px;
  /* background: red; */
}
/* .content {
    width: 100%;
    height: 600px;
    background: var(--neutral-white, #FFF);
    display: flex;
    justify-content: center;

} */
/* .footer {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 10px;
} */
.foot {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}

/* .footer div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
} */
p {
    color: #000;
}

/* .container1 {
  min-height: 70vh;
  background-color: #fff;
  border-radius: 20px;
} */

/* .box {
  max-height: 490px;
  background-color: blue;
} */
.container {
    padding:12px 15px 0 15px;
}
.btn-ok{
    border-radius: 20px;
    height: 56px !important;
    position: absolute;
    bottom: 8%;
   /*  padding: 0 16px; */
}
.v-btn--block {
    min-width: 85% !important;
}
/* .v-input--selection-controls {
    margin-top: 0;
    padding-top: 4px;
} */
.image {
    border-radius: 20px;
    background: var(--neutral-grey-5, #EEF3FC);
    width: 100%;
    height: 233px;
    flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/createBranch.vue